import { UploadImageError } from "../errors/errors";

const MAX_FILE_SIZE_MB = 5;
const IMAGE_PREFIX = "image/";
const S3_UPLOAD_METHOD = "PUT";

// Error messages
const ERROR_NO_FILE = "No file provided.";
const ERROR_NOT_IMAGE = "El archivo debe ser una imagen.";
const ERROR_FILE_TOO_LARGE = `El archivo supera el tamaño máximo de ${MAX_FILE_SIZE_MB} MB.`;
const ERROR_UPLOAD_FAILED = (status: number, statusText: string) =>
  `Fallo la subida a S3: ${status} ${statusText}`;

/**
 * Upload an image to S3 using a presigned URL.
 * Performs validation and throws UploadImageError on failure.
 */
export async function uploadImage(
  file: File,
  uploadUrl: string,
  contentType?: string,
): Promise<void> {
  if (!file) throw new UploadImageError(ERROR_NO_FILE);

  if (!file.type.startsWith(IMAGE_PREFIX)) {
    throw new UploadImageError(ERROR_NOT_IMAGE);
  }

  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    throw new UploadImageError(ERROR_FILE_TOO_LARGE);
  }

  const res = await fetch(uploadUrl, {
    method: S3_UPLOAD_METHOD,
    headers: { "Content-Type": contentType || file.type },
    body: file,
  });

  if (!res.ok) {
    throw new UploadImageError(ERROR_UPLOAD_FAILED(res.status, res.statusText));
  }
}
